export default __webpack_public_path__ + "static/media/Cheese-Web-3.15e9f9af.png";